/**
 * Single chart/data-visualization palette.
 *
 * Replaces the duplicated `ENTITY_COLORS` / `COLORS` arrays that lived in
 * multiple reporting components. Leads with the brand blue and arctic teal,
 * then ranges across hues that stay legible on the Cloud canvas.
 */
import { brand, accent } from './colors';

export const CHART_COLORS = [
	brand[500], // Apple Blue
	accent[500], // Arctic Teal
	'#7C5CFC', // Violet
	'#F2994A', // Amber
	'#EB5757', // Coral
	'#27AE60', // Green
	'#2D9CDB', // Sky
	'#BB6BD9', // Orchid
	brand[800], // Deep blue
	accent[700], // Deep teal
] as const;

/** Color for the Nth series, wrapping the palette if needed. */
export const chartColorAt = (index: number): string =>
	CHART_COLORS[index % CHART_COLORS.length];

export default CHART_COLORS;
